/**
 * Every app's router takes this as its `scrollRestoration` option, so how the page scrolls on a navigation is decided
 * once, here, instead of each page remembering `resetScroll: false`.
 *
 * A new page (another path) or another page of a list (`cursor`) starts at the top; going back restores where you were.
 * Anything else that only changes the address's search (opening a row, a tab, a filter, a search box) keeps the page
 * where it is, so a row opened near the bottom of a table does not throw the reader back to the top.
 */
export function scrollOnNewPage(): (options: { location: { pathname: string; search: unknown } }) => boolean {
  let previous: string | undefined;
  return ({ location }) => {
    const cursor = (location.search as Record<string, unknown> | undefined)?.cursor;
    const page = `${location.pathname}\n${typeof cursor === "string" ? cursor : ""}`;
    const isNewPage = page !== previous;
    previous = page;
    return isNewPage;
  };
}
